import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TReport } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetReportsByType = async ({
  reportStatus,
  dateMin,
  dateMax,
  limit,
  order,
  createdFromType
}: {
  reportStatus: string;
  dateMin: Date;
  dateMax: Date;
  limit: number;
  order: string;
  createdFromType: string;
}): Promise<{
  data: {
    reports: TReport[];
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    reports: TReport[];
  }>(`reports/getReportsByType`, {
    status: reportStatus,
    dateMinObject: getDateAsObject(dateMin),
    dateMaxObject: getDateAsObject(dateMax),
    limit,
    order,
    createdFromType
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { reports: [] },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: { reports: [] },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
